import { toConsumableArray as _toConsumableArray } from '../_virtual/_rollupPluginBabelHelpers.js';
import { formatDate } from '@costar/react-datepicker';
import { getYear, getMonth, add, addDays, subDays, addMonths, addYears, startOfToday } from 'date-fns';
import { getLocaleFormattedYear } from './register-culture.esm.js';
import { TODAY, DEFAULT_DATE_INPUT_MASK, DATE_INPUT_PLACEHOLDER_MONTH_FIRST, DATE_INPUT_PLACEHOLDER_DAY_FIRST, DATE_INPUT_PLACEHOLDER_YEAR_FIRST, DATE_INPUT_MASK_YEAR } from '../constants/index.esm.js';

var FORMAT_TOKEN = '{format}';
function getFormattedMonth(format) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
  var date = arguments.length > 2 ? arguments[2] : undefined;
  var options = arguments.length > 3 ? arguments[3] : undefined;
  var formattedMonth = formatDate(date, format, locale);
  var monthIndex = options.map(function (_ref) {
    var label = _ref.label;
    return label;
  }).indexOf(formattedMonth);
  return options[monthIndex];
}
function getFormattedYear() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en-US';
  var date = arguments.length > 1 ? arguments[1] : undefined;
  var options = arguments.length > 2 ? arguments[2] : undefined;
  var formattedYear = getLocaleFormattedYear(locale, getYear(date));
  var yearIndex = options.map(function (_ref2) {
    var label = _ref2.label;
    return label;
  }).indexOf(formattedYear);
  return options[yearIndex];
}
function generateMonthList(format) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
  var year = arguments.length > 2 ? arguments[2] : undefined;
  var minDate = arguments.length > 3 ? arguments[3] : undefined;
  var maxDate = arguments.length > 4 ? arguments[4] : undefined;
  return _toConsumableArray(Array(12).keys()).map(function (cur, indx) {
    return {
      sortOrder: indx + 1,
      label: formatDate(new Date(getYear(TODAY.asNumber), cur, 1), format, locale),
      disable: !!minDate && (getYear(minDate) > year || getYear(minDate) === year && cur < getMonth(minDate)) || !!maxDate && (getYear(maxDate) < year || getYear(maxDate) === year && cur > getMonth(maxDate))
    };
  });
}
function generateYearList() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en-US';
  var initialDate = arguments.length > 1 ? arguments[1] : undefined;
  var minDate = arguments.length > 2 ? arguments[2] : undefined;
  var maxDate = arguments.length > 3 ? arguments[3] : undefined;
  var defaultMinYear = minDate ? getYear(minDate) : add(TODAY.asDate, {
    years: -50
  });
  var _minDate = minDate !== null && minDate !== void 0 ? minDate : initialDate && getYear(initialDate) < getYear(defaultMinYear) ? add(initialDate, {
    years: -10
  }) : defaultMinYear;
  var startYear = getYear(_minDate);
  var endYear = maxDate ? getYear(maxDate) : getYear(TODAY.asDate);
  var durationYear = endYear - startYear;
  return _toConsumableArray(Array((durationYear !== null && durationYear !== void 0 ? durationYear : 0) + 1).keys()).map(function (cur) {
    return {
      label: getLocaleFormattedYear(locale, startYear + cur)
    };
  });
}
function generateDateList(date, days) {
  return _toConsumableArray(Array(days).keys()).map(function (i) {
    return addDays(date, i);
  });
}
function generateFourWeekDateList(date, days) {
  return _toConsumableArray(Array(days).keys()).map(function (i) {
    return subDays(date, i);
  });
}
function getDateInputMask(localShortDate) {
  var longYearRegex = /yyyy/gi;
  var pattern = DEFAULT_DATE_INPUT_MASK;
  var placeHolder = DATE_INPUT_PLACEHOLDER_MONTH_FIRST;
  if (localShortDate.toLowerCase().startsWith('d')) {
    placeHolder = DATE_INPUT_PLACEHOLDER_DAY_FIRST;
  }
  if (localShortDate.toLowerCase().startsWith('y')) {
    placeHolder = DATE_INPUT_PLACEHOLDER_YEAR_FIRST;
    pattern = DATE_INPUT_MASK_YEAR;
  }
  if (localShortDate.includes('.')) {
    placeHolder = placeHolder.replaceAll('/', '.');
    pattern = pattern.replaceAll('/', '.');
  }
  if (localShortDate.includes('-')) {
    placeHolder = placeHolder.replaceAll('/', '-');
    pattern = pattern.replaceAll('/', '-');
  }
  if (!longYearRegex.test(localShortDate.toLowerCase())) {
    placeHolder = placeHolder.replaceAll('yyyy', 'yy');
  }
  return {
    placeHolder: placeHolder,
    pattern: pattern
  };
}
function parseDateFormat(value) {
  var regex = /\{(.*?)\}/;
  var matches = value ? regex.exec(value) : undefined;
  return matches ? matches[1] : value;
}
function getDateFormat(value) {
  return Array.isArray(value) ? value.map(function (i) {
    return parseDateFormat(i);
  }).filter(function (i) {
    return !!i;
  }) : parseDateFormat(value);
}
function applyFormatTemplate(formattedDate, dateFormat, template) {
  return typeof template === 'string' && template.includes('{') ? template.replace(template !== null && template !== void 0 && template.includes(FORMAT_TOKEN) ? FORMAT_TOKEN : "{".concat(dateFormat, "}"), formattedDate) : formattedDate;
}
var addMonthsToNow = function addMonthsToNow(months) {
  return addMonths(new Date(), months);
};
var subMonthsToNow = function subMonthsToNow(months) {
  return addMonths(new Date(), -1 * months);
};
var addYearsToNow = function addYearsToNow(years) {
  return addYears(new Date(), years);
};
var subYearsToNow = function subYearsToNow(years) {
  return addYears(new Date(), -1 * years);
};
var todaysDate = startOfToday();
var todaysDateISOString = todaysDate.toISOString();
var MINDATE = addYears(todaysDate, -30);
var MINDATEISOSTRING = MINDATE.toISOString();
var MAXDATE = addYears(todaysDate, 100);
var MAXDATEISOSTRING = MAXDATE.toISOString();

export { FORMAT_TOKEN, MAXDATE, MAXDATEISOSTRING, MINDATE, MINDATEISOSTRING, addMonthsToNow, addYearsToNow, applyFormatTemplate, generateDateList, generateFourWeekDateList, generateMonthList, generateYearList, getDateFormat, getDateInputMask, getFormattedMonth, getFormattedYear, subMonthsToNow, subYearsToNow, todaysDate, todaysDateISOString };
//# sourceMappingURL=dates.esm.js.map
